/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import React, { forwardRef, useState, useImperativeHandle, useMemo } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { usePersistFn } from '../_util/usePersistFn.js';
import { useTreeConfig } from './useTreeConfig.js';
import useControllable from './useControllable.js';
import TreeItem from './TreeItem.js';
import { useStore } from './useStore.js';
import { TreeDraggableContext } from './TreeDraggableContext.js';
import parseTNode from '../_util/parseTNode.js';
import '../_chunks/dep-2acfafca.js';
import '../hooks/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../locale/LocalReceiver.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import '../hooks/useControlled.js';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-4559db64.js';
import '../_chunks/dep-c00532d4.js';
import '../_chunks/dep-33ffecad.js';
import '../_chunks/dep-c1f93350.js';
import '../_util/noop.js';
import 'tdesign-icons-react';
import '../loading/index.js';
import '../loading/Loading.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-6c5254c6.js';
import '../_util/easing.js';
import '../common/Portal.js';
import 'react-dom';
import '../loading/gradient.js';
import '../hooks/useDomRefCallback.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-fd3498b6.js';
import '../_chunks/dep-92728dc5.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../_chunks/dep-0e15088f.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-e0370ebe.js';
import '../loading/style/css.js';
import '../loading/type.js';
import '../_util/useRipple.js';
import '../_util/useAnimation.js';
import '../_util/setStyle.js';
import '../hooks/useGlobalIcon.js';
import '../checkbox/index.js';
import '../_chunks/dep-e3db8410.js';
import '../_util/forwardRefWithStatics.js';
import 'hoist-non-react-statics';
import '../common/Check.js';
import '../_chunks/dep-7dad86aa.js';
import '../_util/helper.js';
import '../_chunks/dep-2ffb6f37.js';
import '../_chunks/dep-08c1f545.js';
import '../checkbox/defaultProps.js';
import '../checkbox/style/css.js';
import '../checkbox/type.js';
import './useDraggable.js';
import '../_chunks/dep-b0a01ce1.js';
import '../_chunks/dep-01ce608f.js';
import '../_chunks/dep-77a54538.js';
import '../_util/composeRefs.js';
import '../_chunks/dep-0bc19feb.js';
import '../_chunks/dep-09050977.js';
import '../_chunks/dep-23d0a0bb.js';
import '../_chunks/dep-c8399d32.js';
import '../_util/useUpdateEffect.js';
import '../_util/useLayoutEffect.js';
import '../_common/js/tree/tree-store.js';
import '../_chunks/dep-e51b1270.js';
import '../_chunks/dep-1cec561b.js';
import '../_chunks/dep-7004b0d9.js';
import '../_chunks/dep-e73d1b75.js';
import 'mitt';
import '../_common/js/tree/tree-node.js';
import '../_chunks/dep-a827ffec.js';
import '../_chunks/dep-337b4140.js';
import '../_chunks/dep-ca64038e.js';
import '../_common/js/tree/tree-node-model.js';
import '../_chunks/dep-4f1e1217.js';
import '../_chunks/dep-29cb89ad.js';
import '../_chunks/dep-7b67cdbf.js';
import '../_common/js/log/log.js';
import '../_common/js/log/index.js';
import '../_util/createHookContext.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Tree = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classNames;
  var _useTreeConfig = useTreeConfig(),
    treeClassNames = _useTreeConfig.treeClassNames,
    transitionNames = _useTreeConfig.transitionNames,
    transitionClassNames = _useTreeConfig.transitionClassNames,
    transitionDuration = _useTreeConfig.transitionDuration,
    locale = _useTreeConfig.locale;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    visibleNodes = _useState2[0],
    setVisibleNodes = _useState2[1];
  var empty = props.empty,
    activable = props.activable,
    disabled = props.disabled,
    checkable = props.checkable,
    checkProps = props.checkProps,
    disableCheck = props.disableCheck,
    hover = props.hover,
    icon = props.icon,
    line = props.line,
    label = props.label,
    operations = props.operations,
    transition = props.transition,
    expandOnClickNode = props.expandOnClickNode,
    onClick = props.onClick;
  var _useControllable = useControllable(props),
    value = _useControllable.value,
    onChange = _useControllable.onChange,
    expanded = _useControllable.expanded,
    onExpand = _useControllable.onExpand,
    onActive = _useControllable.onActive,
    actived = _useControllable.actived;
  var emptyText = locale("empty");
  var store = useStore(_objectSpread(_objectSpread({}, props), {}, {
    value: value,
    onChange: onChange,
    expanded: expanded,
    onExpand: onExpand,
    onActive: onActive,
    actived: actived
  }), initial);
  function initial() {
    var nodes = store === null || store === void 0 ? void 0 : store.getNodes();
    var newVisibleNodes = nodes === null || nodes === void 0 ? void 0 : nodes.filter(function (node) {
      return node.visible;
    });
    setVisibleNodes(newVisibleNodes);
  }
  var setExpanded = usePersistFn(function (node, isExpanded, ctx) {
    var e = ctx.e,
      trigger = ctx.trigger;
    var expanded2 = node.setExpanded(isExpanded);
    var treeNodeModel = node === null || node === void 0 ? void 0 : node.getModel();
    (e || trigger) && (onExpand === null || onExpand === void 0 ? void 0 : onExpand(expanded2, {
      node: treeNodeModel,
      e: e,
      trigger: trigger
    }));
    return expanded2;
  });
  var setActived = usePersistFn(function (node, isActived, ctx) {
    var actived2 = node.setActived(isActived);
    var treeNodeModel = node === null || node === void 0 ? void 0 : node.getModel();
    onActive === null || onActive === void 0 ? void 0 : onActive(actived2, _objectSpread({
      node: treeNodeModel
    }, ctx));
    return actived2;
  });
  var setChecked = usePersistFn(function (node, isChecked, ctx) {
    var checked = node.setChecked(isChecked);
    var treeNodeModel = node === null || node === void 0 ? void 0 : node.getModel();
    onChange === null || onChange === void 0 ? void 0 : onChange(checked, _objectSpread({
      node: treeNodeModel
    }, ctx));
    return checked;
  });
  var handleItemClick = function handleItemClick(node, options) {
    if (!node) {
      return;
    }
    var isDisabled = disabled || node.disabled;
    var expand = options.expand,
      active = options.active,
      e = options.e,
      trigger = options.trigger;
    if (expand) setExpanded(node, !node.isExpanded(), {
      e: e,
      trigger: trigger
    });
    if (active && !isDisabled) {
      setActived(node, !node.isActived(), {
        e: e,
        trigger: "node-click"
      });
      var treeNodeModel = node === null || node === void 0 ? void 0 : node.getModel();
      onClick === null || onClick === void 0 ? void 0 : onClick({
        node: treeNodeModel,
        e: e
      });
    }
  };
  var handleChange = function handleChange(node, ctx) {
    if (!node || disabled || node.disabled) {
      return;
    }
    setChecked(node, !node.isChecked(), _objectSpread(_objectSpread({}, ctx), {}, {
      trigger: "node-click"
    }));
  };
  useImperativeHandle(ref, function () {
    return {
      store: store,
      appendTo: function appendTo(value2, newData) {
        var list = [];
        if (Array.isArray(newData)) {
          list = newData;
        } else {
          list = [newData];
        }
        list.forEach(function (item) {
          store.appendNodes(value2, item);
        });
      },
      getIndex: function getIndex(value2) {
        return store.getNodeIndex(value2);
      },
      getItem: function getItem(value2) {
        var node = store.getNode(value2);
        return node === null || node === void 0 ? void 0 : node.getModel();
      },
      getItems: function getItems(value2) {
        var nodes = store.getNodes(value2);
        return nodes.map(function (node) {
          return node.getModel();
        });
      },
      getParent: function getParent(value2) {
        var node = store.getParent(value2);
        return node === null || node === void 0 ? void 0 : node.getModel();
      },
      getParents: function getParents(value2) {
        var nodes = store.getParents(value2);
        return nodes.map(function (node) {
          return node.getModel();
        });
      },
      getPath: function getPath(value2) {
        var node = store.getNode(value2);
        var pathNodes = [];
        if (node) {
          pathNodes = node.getPath().map(function (node2) {
            return node2.getModel();
          });
        }
        return pathNodes;
      },
      insertAfter: function insertAfter(value2, newData) {
        return store.insertAfter(value2, newData);
      },
      insertBefore: function insertBefore(value2, newData) {
        return store.insertBefore(value2, newData);
      },
      remove: function remove(value2) {
        return store.remove(value2);
      },
      setItem: function setItem(value2, options) {
        var node = this.store.getNode(value2);
        var spec = options;
        if (node && spec) {
          if ("expanded" in options) {
            setExpanded(node, spec.expanded, {
              trigger: "setItem"
            });
            delete spec.expanded;
          }
          if ("actived" in options) {
            setActived(node, spec.actived, {
              trigger: "setItem"
            });
            delete spec.actived;
          }
          if ("checked" in options) {
            setChecked(node, spec.checked, {
              trigger: "setItem"
            });
            delete spec.checked;
          }
          node.set(spec);
        }
      }
    };
  }, [store, setExpanded, setActived, setChecked]);
  var nodeList = useMemo(function () {
    return visibleNodes.map(function () {
      return /*#__PURE__*/React.createRef();
    });
  }, [visibleNodes]);
  var renderEmpty = function renderEmpty() {
    return parseTNode(empty, null, emptyText);
  };
  var renderItems = function renderItems() {
    if (visibleNodes.length <= 0) {
      return renderEmpty();
    }
    return /* @__PURE__ */React.createElement(TransitionGroup, {
      name: transitionNames.treeNode,
      className: treeClassNames.treeList
    }, visibleNodes.map(function (node, index) {
      return /* @__PURE__ */React.createElement(CSSTransition, {
        nodeRef: nodeList[index],
        key: node.value,
        timeout: transitionDuration,
        classNames: transitionClassNames
      }, /* @__PURE__ */React.createElement(TreeItem, {
        ref: nodeList[index],
        node: node,
        empty: empty,
        icon: icon,
        label: label,
        line: line,
        transition: transition,
        expandOnClickNode: expandOnClickNode,
        activable: activable,
        operations: operations,
        checkProps: checkProps,
        disableCheck: disableCheck,
        onClick: handleItemClick,
        onChange: handleChange
      }));
    }));
  };
  var draggable = useMemo(function () {
    return {
      props: props,
      store: store
    };
  }, [props, store]);
  return /* @__PURE__ */React.createElement(TreeDraggableContext.Provider, {
    value: draggable
  }, /* @__PURE__ */React.createElement("div", {
    className: classNames(treeClassNames.tree, (_classNames = {}, _defineProperty(_classNames, treeClassNames.disabled, disabled), _defineProperty(_classNames, treeClassNames.treeHoverable, hover), _defineProperty(_classNames, treeClassNames.treeCheckable, checkable), _defineProperty(_classNames, treeClassNames.treeFx, transition), _defineProperty(_classNames, treeClassNames.treeBlockNode, expandOnClickNode), _classNames))
  }, renderItems()));
});
Tree.displayName = "Tree";
Tree.defaultProps = {
  data: [],
  expandLevel: 0,
  icon: true,
  line: false,
  transition: true,
  lazy: true,
  valueMode: "onlyLeaf"
};

export { Tree as default };
//# sourceMappingURL=Tree.js.map
